<cv-loader [size]="'medium'" [overlay]="true" *ngIf="loading"></cv-loader>
<cxone-modal #modal class="cxone-modal" [headerTitle]="headerTitle" [allowClose]="allowClose" [focusOnShow]="true"
    [saveLabel]="saveLabel" [cancelLabel]="cancelLabel"
    (dismissed)="onDismiss()" (closed)="onSave()">
    <div [formGroup]="formDataBinding">
        <cxone-text-area formControlName="notes" #notesTextArea [placeholder]="modalPlaceholder"
        [maxlength]="200"
        (keyup)="formDataBinding.controls['notes'].setValue($event.target['value'].trimStart());noteValue = $event.target['value'].trimStart()"
        (change)="noteValue = $event.target['value'].trimStart()" textAreaId="text-area-2">
        </cxone-text-area>
    </div>
</cxone-modal>